<template>
	<div class="pages">
		<navTitle>
			<div class="activityListInput flex flex-align-center">
				<img src="@/static/images/my/search.png" alt="" />
				<input type="text" class="flex-1" maxlength="50" @input="inputKeyWord" @blur="blurKeyWord" v-model="search_text" placeholder="请输入关键字搜索" />
			</div>
		</navTitle>

		<div class="navTitle flex flex-align-center" v-if="!inputing">
			<div @click="changeType(0)" class="navTitle-item" :class="{'navTitle-itemActive': type == 0}">全部</div>
			<div @click="changeType(1)" class="navTitle-item" :class="{'navTitle-itemActive': type == 1}">最新</div>
		</div>
		<template v-if="dataList.length > 0">
		<van-list
			v-model="loading"	
			:finished="finished"
			:immediate-check="false"
			finished-text="没有更多了"
			@load="onLoad"
			:offset="10"
		>
			<div @click="$router.push({name: 'my_activity'})" class="myactivity flex flex-align-center flex-jus-center"><div class="myactivity-inner flex flex-align-center flex-jus-center">我参与的</div></div>

			<div class="activityList">
				<div class="activityList-item flex" v-for="item in dataList" :key="item.id"  @click="$router.push({ name: 'activityList_details', query: {id: item.id} })">
					<div class="item-img"><img :src="item.pic" alt="" /></div>

					<div class="item-info flex-1 flex flex-column">
						<div class="info-title">{{item.title}}</div>
						<div class="info-time flex flex-align-center">
							<img src="@/static/images/my/time.png" alt="" />
							<div>{{item.startTime}}开始</div>
						</div>
						<div class="info-location flex flex-align-center">
							<img src="@/static/images/my/location.png" alt="" />
							<div>{{item.address}}</div>
						</div>
						<div v-if="item.price*1 == 0" class="info-money">免费</div>
						<div v-else class="info-money">
							<span class="fonS-18">￥{{item.vip_apply_price}}</span>
							<span class="fonS-12 color-00">/起</span>
						</div>
					</div>
					<div v-if="item.quota != -1 && item.join_count>= item.quota" class="item-status item-statusAll">名额已满</div>
					<div class="item-status item-statusAlready">{{item.join_count}}人已报名</div>
					<div v-if="item.end_time*1000 < new Date().getTime()" class="item-status item-statusEnd"></div>
				</div>
			</div>
		</van-list>
		</template>
		<div class="empty" v-if="dataList.length == 0">
			<div class="empty-img">
				<img src="@/static/images/index/emptySearch.png" alt="">
			</div>
			<div class="empty-text">暂无搜索到任何信息</div>
		</div>
		
	</div>
</template>

<script>
/* eslint-disable */
export default {
	data() {
		return {
			search_text: '',
			pageSize: 10,
			page: 1,
			type: 0,
			dataList: [],
			loading: false,
      finished: false,

			search_text: '',
			keyWordList: [],
			keyWordTimer: null, //防抖定时器
			inputing: false
		};
	},
	watch: {
		search_text(newV) {
			// console.log(newV,"neawv",this.debounce);
			this.debounce(800);
		}
	},
	created() {
		this.getList()
	},
	mounted() {
		this.$wx.ready(() => {
      this.$wx.updateAppMessageShareData({
        title: '福建省民族管弦乐学会',
        desc: '活动报名',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
      this.$wx.updateTimelineShareData({
        title: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
    });
	},
	methods: {
		changeType(type) {
			this.type = type
			this.page = 1
			this.getList()
		},
		onLoad() {
			this.page++;
      if (this.page > 1) {
        this.getList();
      }
		},
		getList() {
			this.$get('api/activity/getActivityList', {
				search_text: this.search_text,
				pageSize: this.pageSize,
				page: this.page,
				type: this.type
			}).then(res => {
				this.loading = false;
				let rows = res.data;
        if (rows == null || rows.length === 0) {
          this.finished = true;
          return;
        }
				rows.forEach(item => {
					item.startTime = this.moment(item.start_time * 1000).format('MM月DD日 HH:mm')
				})
				this.dataList.splice((this.page - 1)*10, 10, ...rows)
			})
		},
		inputKeyWord() {
			if (!this.search_text) this.inputing = false;
			else this.inputing = true;
		},
		blurKeyWord() {
			if (!this.search_text) this.inputing = false;
			else this.inputing = true;
		},
		getInfo() {
			this.page = 1
			this.getList()
		},
		debounce(delay) {
			if (this.keyWordTimer) {
				clearTimeout(this.keyWordTimer); 
				this.keyWordTimer = setTimeout(this.getInfo, delay);
			} else {
				this.keyWordTimer = setTimeout(this.getInfo, delay); 
			}
		}
	}
};
</script>

<style scoped lang="stylus">
.pages
	background-color: #f6f6f6;
	min-height 100vh
.fonS-18
	font-size 36px
.fonS-12
	font-size 24px
.color-00
	color #000000
.myactivity
	position fixed
	right 30px
	bottom 120px
	width 112px
	height 112px
	background rgba(222, 17, 60, 0.37)
	border-radius 50%
	z-index 1500
	.myactivity-inner
		width 88px
		height 88px
		background rgba(222, 17, 60, 0.84)
		border-radius 50%
		font-size 20px
		color #FFFFFF
		padding 7px 12px
		text-align center
.activityListInput
	margin 0 auto
	width 492px
	height 72px
	background-color #FFFFFF
	padding 18px 26px
	border-radius 46px
	img
		width 34px
		height 36px
		margin-right 26px
	input
		font-size 26px
		color #000000
	input::-webkit-input-placeholder
		color #B1B1B1
		font-size 26px
	input::-moz-placeholder /* Mozilla Firefox 19+ */
		color #ABABAB
		font-size 26px
	input:-moz-placeholder /* Mozilla Firefox 4 to 18 */
		color #ABABAB
		font-size 26px
	input:-ms-input-placeholder /* Internet Explorer 10-11 */
		color #ABABAB
		font-size 26px
.navTitle
	padding 0 32px
	width 100%
	border-bottom 2px solid #E2E2E2
	height 94px
	position relative
	z-index 101
	// overflow hidden
	.navTitle-item
		font-size 28px
		color #000000
		margin-right 80px
	.navTitle-itemActive
		font-size 36px
		font-weight 800
		color #DE113C
		position relative
		&::after
			content ' '
			position absolute
			left 0
			bottom -24px
			width 100%
			height 6px
			background #DE113C
.activityList
	padding 30px
	.activityList-item
		background-color #FFFFFF
		border-radius 20px
		margin-bottom 28px
		padding 20px 24px 32px 24px
		position relative
		.item-img
			width 188px
			height 188px
			margin-right 24px
			border-radius 20px
			img
				border-radius 20px
		.item-info
			.info-title
				font-size 30px
				color #000000
			.info-time
				font-size 24px
				color #B1B1B1
				margin-top 18px
				margin-bottom 18px
				img
					width 26px
					height 26px
					margin-right 12px
			.info-location
				font-size 24px
				color #B1B1B1
				margin-bottom 20px
				img
					width 21px
					height 26px
					margin-right 18px
			.info-money
				font-size 30px
				color #DE113C
		.item-status
			position absolute
			bottom 32px
			right 24px
		.item-statusAll
			font-size 24px
			color #9E9E9E
		.item-statusAlready
			font-size 24px
			color #DE113C
		.item-statusEnd
			z-index 10
			width 155px
			height 136px
			background-image url('~@/static/images/index/activityEnd.png')
			background-size 100% 100%
			background-position center
.empty
	background-color inherit
	.empty-img
		margin 280px auto 0 auto
		width 373px
		height 320px
		img
			width 100%
			height 100%
	.empty-text
		width 100%
		text-align center
		margin-top 22px
		font-size: 26px;
		color: #111111;
</style>
